import { baseThemeValues } from 'constants/common';

const itemBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 500,
};

export const transferListTheme = {
  body: {
    bg: 'palette.surface.3',
    connectLine: 'palette.tertiary.30',
    connectLineLight: 'palette.tertiary.20:0.6',
    item: {
      base: {
        ...itemBase,
        bg: 'palette.transparent',
        text: 'palette.tertiary.70',
      },
      hover: {
        ...itemBase,
        bg: 'palette.surface.4',
        text: 'palette.tertiary.95',
      },
      pressed: {
        ...itemBase,
        bg: 'palette.transparent',
        text: 'palette.tertiary.95',
      },
    },
    moveButton: {
      active: {
        bg: 'palette.surface.4',
        borderColor: 'palette.transparent',
        borderRadius: '12px',
        borderWidth: '0px',
        text: 'palette.tertiary.95',
      },
      base: {
        bg: 'palette.surface.4',
        borderColor: 'palette.transparent',
        borderRadius: '12px',
        borderWidth: '0px',
        text: 'palette.tertiary.50',
      },
      disabled: {
        bg: 'palette.surface.2',
        borderColor: 'palette.transparent',
        borderRadius: '12px',
        borderWidth: '0px',
        text: 'palette.neutral.20',
      },
      hover: {
        bg: 'palette.surface.5',
        borderColor: 'palette.transparent',
        borderRadius: '12px',
        borderWidth: '0px',
        text: 'palette.primary.10',
      },
      pressed: {
        bg: 'palette.surface.4',
        borderColor: 'palette.transparent',
        borderRadius: '12px',
        borderWidth: '0px',
        text: 'palette.primary.20',
      },
    },
    separateLine: 'palette.tertiary.30',
    separateLineLight: 'palette.tertiary.20:0.6',
  },
  header: {
    left: {
      bg: 'palette.tertiary.60',
      borderColor: 'palette.transparent',
      borderRadius: '8px',
      borderWidth: '0px',
      circle: 'palette.tertiary.80',
      endIcon: 'palette.tertiary.5',
      icon: 'palette.tertiary.10',
      options: {
        hover: 'palette.tertiary.5',
      },
      subtitle: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '14px',
        fontWeight: 400,
        text: 'palette.tertiary.5',
      },
      title: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '24px',
        fontWeight: 700,
        text: 'palette.tertiary.5',
      },
    },
    right: {
      bg: 'palette.secondary.60',
      borderColor: 'palette.transparent',
      borderRadius: '8px',
      borderWidth: '0px',
      circle: 'palette.secondary.80',
      icon: 'palette.secondary.10',
      subtitle: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '14px',
        fontWeight: 400,
        text: 'palette.secondary.5',
      },
      title: {
        fontFamily: baseThemeValues.inherit,
        fontSize: '24px',
        fontWeight: 700,
        text: 'palette.secondary.5',
      },
    },
  },
};
